var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form-group",
      class: {
        "form-group--float": _vm.floatStyle,
        "form-group--focus": _vm.isInputFocused,
        "form-group--is-invalid": !_vm.valid,
      },
    },
    [
      _vm.title
        ? _c(
            "label",
            {
              staticClass: "text-white font-weight-bold",
              attrs: { for: _vm.id },
            },
            [_vm._v(_vm._s(_vm.title))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        staticClass: "form-control",
        class:
          ((_obj = {
            "is-invalid": !_vm.valid && (_vm.showHint || _vm.floatStyle),
          }),
          (_obj["align-" + _vm.textAlign] = true),
          (_obj[_vm.inputClasses] = true),
          _obj),
        attrs: {
          id: _vm.id,
          type: "text",
          name: _vm.elementName,
          disabled: _vm.disabled,
          "aria-step": _vm.step,
          "aria-valuemin": _vm.min != null ? _vm.min : null,
          "aria-valuemax": _vm.max != null ? _vm.max : null,
          "aria-valuenow": _vm.internalValue,
        },
        domProps: { value: _vm.formattedValue },
        on: {
          blur: _vm.onInputBlur,
          focus: _vm.onInputFocus,
          keydown: _vm.onInputKeyPress,
        },
      }),
      _vm._v(" "),
      !_vm.floatStyle
        ? [
            _vm.showHint && !_vm.valid && _vm.errorMessage
              ? [
                  _c("div", { staticClass: "invalid-feedback" }, [
                    _vm._v(
                      "\n        " + _vm._s(_vm.errorMessage) + "\n      "
                    ),
                  ]),
                ]
              : _vm.description
              ? [
                  _c("small", {
                    staticClass: "text-secondary form-text",
                    domProps: { innerHTML: _vm._s(_vm.description) },
                  }),
                ]
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }